import {
    NatPutContactAddressOnEmergencyRequest,
    NatPutContactAddressOnEmergencyResponse
} from './NatPutContactAddressOnEmergency'
import {NatPutBicycleParkingUseApplyRequest, NatPutBicycleParkingUseApplyResponse} from './NatPutBicycleParkingUseApply'
import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {NatPutParkingUsesRequest, NatPutParkingUsesResponse} from './NatPutParkingUses'
import {NatGetContactAddressOnEmergencyResponse} from './NatGetContactAddressOnEmergency'
import {NatGetApplicationStatus} from './NatGetApplicationStatus'
import {
    NatPutRejectionContactAddressOnEmergencyRequest,
    NatPutRejectionContactAddressOnEmergencyResponse
} from './NatPutRejectionContactAddressOnEmergency'
import {
    NatPutApprovalContactAddressOnEmergencyResponse,
    NatPutApprovalsContactAddressOnEmergencyRequest
} from './NatPutReceptionContactAddressOnEmergency'
import {NatPutBikeParkingUseApplyRequest, NatPutBikeParkingUseApplyResponse} from './NatPutBikeParkingUseApply'
import {NatGetApplicationCategory} from './NatGetApplicationCategory'
import {NatGetApplications, SearchCondition} from './NatGetApplications'
import {SortOrder} from '../../../../components/shared/SortOrder'
import {NatGetParkingUsesResponse} from './NatGetParkingUses'
import {
    NatPutRejectionParkingUsesRequest,
    NatPutRejectionParkingUsesResponse
} from './NatPutRejectionParkingUsesRequest'
import {
    NatPutApprovalParkingUsesResponse,
    NatPutApprovalsParkingUsesRequest
} from './NatPutApprovalsParkingUsesRequest'
import {NatGetBicycleParkingUseApplyResponse} from './NatGetBicycleParkingUseApply'
import {
    NatPutRejectionBicycleParkingUseApplyRequest,
    NatPutRejectionBicycleParkingUseApplyResponse
} from './NatPutRejectionBicycleParkingUseApply'
import {
    NatPutApprovalBicycleParkingUseApplyResponse,
    NatPutApprovalsBicycleParkingUseApplyRequest
} from './NatPutReceptionBicycleParkingUseApply'
import {
    NatPutBicycleParkingUseWithdrawalApplyRequest,
    NatPutBicycleParkingUseWithdrawalApplyResponse
} from './NatPutBicycleParkingUseWithdrawal';
import {NatGetBicycleParkingUseWithdrawalResponse} from './NatGetBicycleParkingUseWithdrawal'
import {
    NatPutRejectionBicycleParkingUseWithdrawalRequest,
    NatPutRejectionBicycleParkingUseWithdrawalResponse
} from './NatPutRejectionBicycleParkingUseWithdrawalRequest'
import {
    NatPutApprovalBicycleParkingUseWithdrawalResponse,
    NatPutApprovalsBicycleParkingUseWithdrawalRequest
} from './NatPutApprovalsBicycleParkingUseWithdrawalRequest'
import {NatPutPetBreedingApplyRequest, NatPutPetBreedingApplyResponse} from './NatPutPetBreedingApply'
import {NatGetBikeParkingUseApplyResponse} from './NatGetBikeParkingUseApply'
import {
    NatPutRejectionBikeParkingUseApplyRequest,
    NatPutRejectionBikeParkingUseApplyResponse
} from './NatPutRejectionBikeParkingUseApply'
import {
    NatPutApprovalsBikeParkingUseApplyRequest,
    NatPutApprovalsBikeParkingUseApplyResponse
} from './NatPutApprovalsBikeParkingUseApply';
import {
    NatPutApprovalPetBreedingResponse,
    NatPutApprovalsPetBreedingRequest
} from './NatPutApprovalsPetBreedingRequest'
import {NatGetPetBreedingResponse} from './NatGetPetBreeding'
import {
    NatPutRejectionPetBreedingRequest,
    NatPutRejectionPetBreedingResponse
} from './NatPutRejectionPetBreedingRequest'
import {
    NatPutPetMedicalCheckUpReportApplyRequest,
    NatPutPetMedicalCheckUpReportApplyResponse
} from './NatPutPetMedicalCheckUpReport';
import {NatGetPetMedicalCheckUpReportResponse} from './NatGetPetMedicalCheckUpReport'
import {
    NatPutRejectionPetMedicalCheckUpReportRequest,
    NatPutRejectionPetMedicalCheckUpReportResponse
} from './NatPutRejectionPetMedicalCheckUpReportRequest'
import {
    NatPutApprovalPetMedicalCheckUpReportResponse,
    NatPutApprovalsPetMedicalCheckUpReportRequest
} from './NatPutApprovalsPetMedicalCheckUpReportRequest'
import {NatGetBikeParkingUseChangeApplyResponse} from './NatGetBikeParkingUseChangeApply'
import {
    NatPutBikeParkingUseChangeApplyRequest,
    NatPutBikeParkingUseChangeApplyResponse
} from './NatPutBikeParkingUseChangeApply'
import {
    NatPutRejectionBikeParkingUseChangeApplyRequest,
    NatPutRejectionBikeParkingUseChangeApplyResponse
} from './NatPutRejectionBikeParkingUseChangeApply'
import {
    NatPutApprovalsBikeParkingUseChangeApplyRequest,
    NatPutApprovalsBikeParkingUseChangeApplyResponse
} from './NatPutApprovalsBikeParkingUseChangeApply';
import {NatPutParkingUsesChangeRequest, NatPutParkingUsesChangeResponse} from './NatPutParkingUsesChange'
import {NatGetParkingUsesChangeResponse} from './NatGetParkingUsesChange';
import {
    NatPutRejectionParkingUsesChangeRequest,
    NatPutRejectionParkingUsesChangeResponse
} from './NatPutRejectionParkingUsesChangeRequest'
import {
    NatPutApprovalParkingUsesChangeResponse,
    NatPutApprovalsParkingUsesChangeRequest
} from './NatPutApprovalsParkingUsesChangeRequest'
import {NatPutPetBreedingStopRequest, NatPutPetBreedingStopResponse} from './NatPutPetBreedingStop'
import {NatGetPetBreedingStopResponse} from './NatGetPetBreedingStop'
import {
    NatPutRejectionPetBreedingStopRequest,
    NatPutRejectionPetBreedingStopResponse
} from './NatPutRejectionPetBreedingStopRequest'
import {
    NatPutApprovalPetBreedingStopResponse,
    NatPutApprovalsPetBreedingStopRequest
} from './NatPutApprovalsPetBreedingStopRequest'
import {NatPutConstructionRequest, NatPutConstructionResponse} from './NatPutConstruction'
import {NatGetConstructionApplyResponse} from './NatGetConstructionApply'
import {
    NatPutRejectionConstructionApplyRequest,
    NatPutRejectionConstructionApplyResponse
} from './NatPutRejectionConstructionApply'
import {
    NatPutApprovalsConstructionApplyRequest,
    NatPutApprovalsConstructionApplyResponse
} from './NatPutApprovalsConstructionApply'
import {
    NatPutConstructionCompleteRequest,
    NatPutConstructionCompleteResponse
} from './NatPutConstructionComplete';
import {NatGetConstructionCompleteResponse} from './NatGetConstructionComplete';
import {
    NatPutRejectionConstructionCompleteRequest,
    NatPutRejectionConstructionCompleteResponse
} from './NatPutRejectionConstructionCompleteRequest';
import {
    NatPutApprovalConstructionCompleteResponse,
    NatPutApprovalsConstructionCompleteRequest
} from './NatPutApprovalsConstructionCompleteRequest';
import {
    NatPutParkingUsesWithdrawalRequest,
    NatPutParkingUsesWithdrawalResponse
}from './NatPutParkingUsesWithdrawal'
import {
    NatPutRejectionParkingUsesWithdrawalRequest,
    NatPutRejectionParkingUsesWithdrawalResponse
} from './NatPutRejectionParkingUsesWithdrawalRequest'
import {
    NatPutApprovalParkingUsesWithdrawalResponse,
    NatPutApprovalsParkingUsesWithdrawalRequest
} from './NatPutApprovalsParkingUsesWithdrawalRequest'
import {NatGetParkingUsesWithdrawalResponse} from './NatGetParkingUsesWithdrawal'
import {NatGetApplicationResult} from './NatGetApplicationResult'
import {NatGetBikeParkingUseWithdrawalApplyResponse} from './NatGetBikeParkingUseWithdrawalApply'
import {
    NatPutBikeParkingUseWithdrawalApplyRequest,
    NatPutBikeParkingUseWithdrawalApplyResponse
} from './NatPutBikeParkingUseWithdrawalApply'
import {
    NatPutRejectionBikeParkingUseWithdrawalApplyRequest,
    NatPutRejectionBikeParkingUseWithdrawalApplyResponse
} from './NatPutRejectionBikeParkingUseWithdrawalApply'
import {
    NatPutApprovalsBikeParkingUseWithdrawalApplyRequest,
    NatPutApprovalsBikeParkingUseWithdrawalApplyResponse
} from './NatPutApprovalsBikeParkingUseWithdrawalApply';
import {NatPutWindowFilmAttachRequest, NatPutWindowFilmAttachResponse} from './NatPutWindowFilmAttach';
import {
    NatPutApprovalsWindowFilmAttachApplyRequest,
    NatPutApprovalsWindowFilmAttachApplyResponse
} from './NatPutApprovalsWindowFilmAttachApply';
import {
    NatPutRejectionWindowFilmAttachApplyRequest,
    NatPutRejectionWindowFilmAttachApplyResponse
} from './NatPutRejectionWindowFilmAttachApply';
import {NatGetWindowFilmAttachApplyResponse} from './NatGetWindowFilmAttachApply';
import {NatPutBrowseRequest, NatPutBrowseResponse} from './NatPutBrowse'
import {NatPutRejectionBrowseApplyRequest, NatPutRejectionBrowseApplyResponse} from './NatPutRejectionBrowseApply'
import {NatPutApprovalsBrowseApplyRequest, NatPutApprovalsBrowseApplyResponse} from './NatPutApprovalsBrowseApply'
import {NatGetBrowseApplyResponse} from './NatGetBrowseApply'
import {NatGetApplyHistoryList} from './NatGetApplyHistoryList'
import {NatPutLongAbsenceRequest, NatPutLongAbsenceResponse} from './NatPutLongAbsence'
import {NatGetLongAbsenceResponse} from './NatGetLongAbsence'
import {
    NatPutRejectionLongAbsenceRequest,
    NatPutRejectionLongAbsenceResponse
} from './NatPutRejectionLongAbsenceRequest'
import {
    NatPutApprovalsLongAbsenceRequest,
    NatPutApprovalsLongAbsenceResponse
} from './NatPutApprovalsLongAbsenceRequest'
import {NatPutHeavyLoadsCarryRequest, NatPutHeavyLoadsCarryResponse} from './NatPutHeavyLoadsCarry';
import {NatGetHeavyLoadsCarryApplyResponse} from './NatGetHeavyLoadsCarryApply';
import {
    NatPutRejectionHeavyLoadsCarryApplyRequest,
    NatPutRejectionHeavyLoadsCarryApplyResponse
} from './NatPutRejectionHeavyLoadsCarryApply';
import {
    NatPutApprovalsHeavyLoadsCarryApplyRequest,
    NatPutApprovalsHeavyLoadsCarryApplyResponse
} from './NatPutApprovalsHeavyLoadsCarryApply';
import {
    NatPostResidentUserRegistrationRequest,
    NatPostResidentUserRegistrationResponse
} from './NatPostResidentUserRegistration'
import {NatGetUserRegistrationApplyList, UserRegistrationApplySearchCondition} from './NatGetUserRegistrationApplyList';
import {NatGetUserRegistrationApply} from './NatGetUserRegistrationApply';
import {
    NatPutApprovalUseRegistrationApplyRequest,
    NatPutApprovalUseRegistrationApplyResponse
} from './NatPutApprovalUserRegistrationApplyRequest';
import {NatPutRejectionUserRegistrationApplyRequest} from './NatPutRejectionUserRegistrationApplyRequest'

export class NatApplicationRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async getApplicationStatus(condominiumCd: string, applyId: string):
        Promise<NatGetApplicationStatus> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/${applyId}/statuses`
        )
    }

    async getApplyHistoryList(condominiumCd: string, applyRegisterDateTime?: string):
        Promise<NatGetApplyHistoryList> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/applyHistory`,
            {
                applyRegisterDateTime: applyRegisterDateTime
            },
            ContentType.JSON);
    }

    async getContactAddressOnEmergency(condominiumCd: string, applyId: string):
        Promise<NatGetContactAddressOnEmergencyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/contactAddressOnEmergencies/${applyId}`
        )
    }

    async getContactAddressOnEmergencyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetContactAddressOnEmergencyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/contactAddressOnEmergencies/${applyId}`
        )
    }

    async approvalContactAddressOnEmergency(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsContactAddressOnEmergencyRequest
    ): Promise<NatPutApprovalContactAddressOnEmergencyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/contactAddressOnEmergencies/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async rejectionContactAddressOnEmergency(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionContactAddressOnEmergencyRequest
    ): Promise<NatPutRejectionContactAddressOnEmergencyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/contactAddressOnEmergencies/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async applyContactAddressOnEmergency(
        condominiumCd: string,
        request: NatPutContactAddressOnEmergencyRequest
    ): Promise<NatPutContactAddressOnEmergencyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/contactAddressOnEmergencies`,
            request,
            ContentType.JSON,
        )
    }

    async applyParkingUses(
        condominiumCd: string,
        request: NatPutParkingUsesRequest
    ): Promise<NatPutParkingUsesResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/parkingUses`,
            request,
            ContentType.JSON,
        )
    }

    async applyParkingUsesChange(
        condominiumCd: string,
        request: NatPutParkingUsesChangeRequest
    ): Promise<NatPutParkingUsesChangeResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/parkingUsesChange`,
            request,
            ContentType.JSON,
        )
    }

    async applyParkingUsesWithdrawal(
        condominiumCd: string,
        request: NatPutParkingUsesWithdrawalRequest
    ): Promise<NatPutParkingUsesWithdrawalResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/parkingUsesWithdrawal`,
            request,
            ContentType.JSON,
        )
    }

    async getBicycleParkingUseApply(condominiumCd: string, applyId: string):
        Promise<NatGetBicycleParkingUseApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/bicycleParkingUses/${applyId}`
        )
    }

    async getBicycleParkingUseApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetBicycleParkingUseApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/bicycleParkingUses/${applyId}`
        )
    }

    async approvalBicycleParkingUseApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsBicycleParkingUseApplyRequest
    ): Promise<NatPutApprovalBicycleParkingUseApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bicycleParkingUses/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async rejectionBicycleParkingUseApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionBicycleParkingUseApplyRequest
    ): Promise<NatPutRejectionBicycleParkingUseApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bicycleParkingUses/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async applyBicycleParkingUseApply(
        condominiumCd: string,
        request: NatPutBicycleParkingUseApplyRequest
    ): Promise<NatPutBicycleParkingUseApplyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/bicycleParkingUses`,
            request,
            ContentType.JSON,
        )
    }

    async applyBicycleParkingUseWithdrawal(
        condominiumCd: string,
        request: NatPutBicycleParkingUseWithdrawalApplyRequest
    ): Promise<NatPutBicycleParkingUseWithdrawalApplyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/bicycleParkingUsesWithdrawal`,
            request,
            ContentType.JSON,
        )
    }

    async getBicycleParkingUseWithdrawal(condominiumCd: string, applyId: string):
        Promise<NatGetBicycleParkingUseWithdrawalResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/bicycleParkingUsesWithdrawal/${applyId}`
        )
    }

    async getBicycleParkingUseWithdrawalForResident(condominiumCd: string, applyId: string):
        Promise<NatGetBicycleParkingUseWithdrawalResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/bicycleParkingUsesWithdrawal/${applyId}`
        )
    }

    async rejectionBicycleParkingUseWithdrawal(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionBicycleParkingUseWithdrawalRequest
    ): Promise<NatPutRejectionBicycleParkingUseWithdrawalResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bicycleParkingUsesWithdrawal/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalBicycleParkingUseWithdrawal(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsBicycleParkingUseWithdrawalRequest
    ): Promise<NatPutApprovalBicycleParkingUseWithdrawalResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bicycleParkingUsesWithdrawal/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async getBikeParkingUseApply(condominiumCd: string, applyId: string):
        Promise<NatGetBikeParkingUseApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUses/${applyId}`
        )
    }

    async getBikeParkingUseApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetBikeParkingUseApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/bikeParkingUses/${applyId}`
        )
    }

    async applyBikeParkingUseApply(
        condominiumCd: string,
        request: NatPutBikeParkingUseApplyRequest
    ): Promise<NatPutBikeParkingUseApplyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/bikeParkingUses`,
            request,
            ContentType.JSON,
        )
    }

    async rejectionBikeParkingUseApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionBikeParkingUseApplyRequest
    ): Promise<NatPutRejectionBikeParkingUseApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUses/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalBikeParkingUseApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsBikeParkingUseApplyRequest
    ): Promise<NatPutApprovalsBikeParkingUseApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUses/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async getBikeParkingUseChangeApply(condominiumCd: string, applyId: string):
        Promise<NatGetBikeParkingUseChangeApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesChange/${applyId}`
        )
    }

    async getBikeParkingUseChangeApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetBikeParkingUseChangeApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/bikeParkingUsesChange/${applyId}`
        )
    }

    async applyBikeParkingUseChangeApply(
        condominiumCd: string,
        request: NatPutBikeParkingUseChangeApplyRequest
    ): Promise<NatPutBikeParkingUseChangeApplyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/bikeParkingUsesChange`,
            request,
            ContentType.JSON,
        )
    }

    async rejectionBikeParkingUseChangeApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionBikeParkingUseChangeApplyRequest
    ): Promise<NatPutRejectionBikeParkingUseChangeApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesChange/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalBikeParkingUseChangeApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsBikeParkingUseChangeApplyRequest
    ): Promise<NatPutApprovalsBikeParkingUseChangeApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesChange/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async getBikeParkingUseWithdrawalApply(condominiumCd: string, applyId: string):
        Promise<NatGetBikeParkingUseWithdrawalApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesWithdrawal/${applyId}`
        )
    }

    async getBikeParkingUseWithdrawalApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetBikeParkingUseWithdrawalApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/bikeParkingUsesWithdrawal/${applyId}`
        )
    }

    async applyBikeParkingUseWithdrawalApply(
        condominiumCd: string,
        request: NatPutBikeParkingUseWithdrawalApplyRequest
    ): Promise<NatPutBikeParkingUseWithdrawalApplyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/bikeParkingUsesWithdrawal`,
            request,
            ContentType.JSON,
        )
    }

    async rejectionBikeParkingUseWithdrawalApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionBikeParkingUseWithdrawalApplyRequest
    ): Promise<NatPutRejectionBikeParkingUseWithdrawalApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesWithdrawal/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalBikeParkingUseWithdrawalApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsBikeParkingUseWithdrawalApplyRequest
    ): Promise<NatPutApprovalsBikeParkingUseWithdrawalApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/bikeParkingUsesWithdrawal/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async applyPetBreedingApply(
        condominiumCd: string,
        request: NatPutPetBreedingApplyRequest
    ): Promise<NatPutPetBreedingApplyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/breedingPets`,
            request,
            ContentType.JSON,
        )
    }

    async getPetBreeding(condominiumCd: string, applyId: string):
        Promise<NatGetPetBreedingResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/breedingPets/${applyId}`
        )
    }

    async rejectionPetBreeding(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionPetBreedingRequest
    ): Promise<NatPutRejectionPetBreedingResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/breedingPets/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalPetBreeding(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsPetBreedingRequest
    ): Promise<NatPutApprovalPetBreedingResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/breedingPets/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async getApplicationCategory(condominiumCd?: string): Promise<NatGetApplicationCategory> {
        if (condominiumCd) {
            return await this.http.get(`/api/common/condominiums/${condominiumCd}/applications/categories`);
        }

        return await this.http.get(`/api/admin/applications/categories`);
    }

    async getApplicationForAllMode(
        searchCondition?: SearchCondition,
        searchConditionSortInfo?: SortOrder[],
    ): Promise<NatGetApplications> {
        const sortInfos: string[] = []
        if (searchConditionSortInfo) {
            searchConditionSortInfo.forEach((sortInfo) => {
                sortInfos.push(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
            })
        }

        return await this.http.post(
            `/api/admin/applications`,
            {
                condominiumGroupId: searchCondition?.condominiumGroupId || null,
                businessCenterSupport: searchCondition?.businessCenterSupport || null,
                condominiumCd: searchCondition?.condominiumCd || null,
                condominiumName: searchCondition?.condominiumName || null,
                applyStatus: searchCondition?.applyStatus || null,
                applyCategory: searchCondition?.applyCategory || null,
                applyId: searchCondition?.applyId || null,
                pageNum: searchCondition?.pageNum ?? null,
                page: searchCondition?.page ?? null,
                sortInfo: sortInfos,
            },
            ContentType.JSON
        )
    }

    async getApplication(
        condominiumCd?: string,
        searchCondition?: SearchCondition,
        searchConditionSortInfo?: SortOrder[],
    ): Promise<NatGetApplications> {
        const sortInfos: string[] = []
        if (searchConditionSortInfo) {
            searchConditionSortInfo.forEach((sortInfo) => {
                sortInfos.push(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
            })
        }

        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications`,
            {
                applyStatus: searchCondition?.applyStatus || null,
                applyCategory: searchCondition?.applyCategory || null,
                applyId: searchCondition?.applyId || null,
                ridgeCd: searchCondition?.ridgeCd || null,
                roomNumber: searchCondition?.roomNumber || null,
                pageNum: searchCondition?.pageNum ?? null,
                page: searchCondition?.page ?? null,
                sortInfo: sortInfos,
            },
            ContentType.JSON
        )
    }

    async getParkingUses(condominiumCd: string, applyId: string):
        Promise<NatGetParkingUsesResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUses/${applyId}`
        )
    }

    async rejectionParkingUses(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionParkingUsesRequest
    ): Promise<NatPutRejectionParkingUsesResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUses/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalParkingUses(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsParkingUsesRequest
    ): Promise<NatPutApprovalParkingUsesResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUses/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async getParkingUsesChange(condominiumCd: string, applyId: string):
        Promise<NatGetParkingUsesChangeResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUsesChange/${applyId}`
        )
    }

    async getParkingUsesChangeForResident(condominiumCd: string, applyId: string):
        Promise<NatGetParkingUsesChangeResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/parkingUsesChange/${applyId}`
        )
    }

    async rejectionParkingUsesChange(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionParkingUsesChangeRequest
    ): Promise<NatPutRejectionParkingUsesChangeResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUsesChange/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalParkingUsesChange(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsParkingUsesChangeRequest
    ): Promise<NatPutApprovalParkingUsesChangeResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUsesChange/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async getParkingUsesWithdrawal(condominiumCd: string, applyId: string):
        Promise<NatGetParkingUsesWithdrawalResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUsesWithdrawal/${applyId}`
        )
    }

    async getParkingUsesWithdrawalForResident(condominiumCd: string, applyId: string):
        Promise<NatGetParkingUsesWithdrawalResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/parkingUsesWithdrawal/${applyId}`
        )
    }

    async rejectionParkingUsesWithdrawal(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionParkingUsesWithdrawalRequest
    ): Promise<NatPutRejectionParkingUsesWithdrawalResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUsesWithdrawal/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalParkingUsesWithdrawal(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsParkingUsesWithdrawalRequest
    ): Promise<NatPutApprovalParkingUsesWithdrawalResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/parkingUsesWithdrawal/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async applyPetMedicalCheckUpReport(
        condominiumCd: string,
        request: NatPutPetMedicalCheckUpReportApplyRequest
    ): Promise<NatPutPetMedicalCheckUpReportApplyResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/petMedicalCheckUpReport`,
            request,
            ContentType.JSON,
        )
    }

    async getPetMedicalCheckUpReport(condominiumCd: string, applyId: string):
        Promise<NatGetPetMedicalCheckUpReportResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/petMedicalCheckUpReport/${applyId}`
        )
    }

    async rejectionPetMedicalCheckUpReport(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionPetMedicalCheckUpReportRequest
    ): Promise<NatPutRejectionPetMedicalCheckUpReportResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/petMedicalCheckUpReport/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalPetMedicalCheckUpReport(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsPetMedicalCheckUpReportRequest
    ): Promise<NatPutApprovalPetMedicalCheckUpReportResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/petMedicalCheckUpReport/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async applyPetBreedingStop(
        condominiumCd: string,
        request: NatPutPetBreedingStopRequest
    ): Promise<NatPutPetBreedingStopResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/breedingPetsStop`,
            request,
            ContentType.JSON,
        )
    }

    async getPetBreedingStop(condominiumCd: string, applyId: string):
        Promise<NatGetPetBreedingStopResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/breedingPetsStop/${applyId}`
        )
    }

    async rejectionPetBreedingStop(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionPetBreedingStopRequest
    ): Promise<NatPutRejectionPetBreedingStopResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/breedingPetsStop/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalPetBreedingStop(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsPetBreedingStopRequest
    ): Promise<NatPutApprovalPetBreedingStopResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/breedingPetsStop/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async applyConstruction(
        condominiumCd: string,
        request: NatPutConstructionRequest
    ): Promise<NatPutConstructionResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/constructions`,
            request,
            ContentType.JSON,
        )
    }

    async getConstructionApply(condominiumCd: string, applyId: string):
        Promise<NatGetConstructionApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/constructions/${applyId}`
        )
    }

    async getConstructionApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetConstructionApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/constructions/${applyId}`
        )
    }

    async rejectionConstructionApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionConstructionApplyRequest
    ): Promise<NatPutRejectionConstructionApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/constructions/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalConstructionApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsConstructionApplyRequest
    ): Promise<NatPutApprovalsConstructionApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/constructions/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async applyConstructionComplete(
        condominiumCd: string,
        request: NatPutConstructionCompleteRequest
    ): Promise<NatPutConstructionCompleteResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/constructionComplete`,
            request,
            ContentType.JSON,
        )
    }

    async getConstructionComplete(condominiumCd: string, applyId: string):
        Promise<NatGetConstructionCompleteResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/constructionComplete/${applyId}`
        )
    }

    async rejectionConstructionComplete(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionConstructionCompleteRequest
    ): Promise<NatPutRejectionConstructionCompleteResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/constructionComplete/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalConstructionComplete(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsConstructionCompleteRequest
    ): Promise<NatPutApprovalConstructionCompleteResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/constructionComplete/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async applyWindowFilmAttach(
        condominiumCd: string,
        request: NatPutWindowFilmAttachRequest
    ): Promise<NatPutWindowFilmAttachResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/windowFilmAttaches`,
            request,
            ContentType.JSON,
        )
    }

    async getWindowFilmAttachApply(condominiumCd: string, applyId: string):
        Promise<NatGetWindowFilmAttachApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/windowFilmAttaches/${applyId}`
        )
    }

    async getWindowFilmAttachApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetWindowFilmAttachApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/windowFilmAttaches/${applyId}`
        )
    }

    async rejectionWindowFilmAttachApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionWindowFilmAttachApplyRequest
    ): Promise<NatPutRejectionWindowFilmAttachApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/windowFilmAttaches/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalWindowFilmAttachApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsWindowFilmAttachApplyRequest
    ): Promise<NatPutApprovalsWindowFilmAttachApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/windowFilmAttaches/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }


    async applyBrowse(
        condominiumCd: string,
        request: NatPutBrowseRequest
    ): Promise<NatPutBrowseResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/browses`,
            request,
            ContentType.JSON,
        )
    }

    async getBrowseApply(condominiumCd: string, applyId: string):
        Promise<NatGetBrowseApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/browses/${applyId}`
        )
    }

    async rejectionBrowseApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionBrowseApplyRequest
    ): Promise<NatPutRejectionBrowseApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/browses/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalBrowseApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsBrowseApplyRequest
    ): Promise<NatPutApprovalsBrowseApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/browses/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async applyLongAbsence(
        condominiumCd: string,
        request: NatPutLongAbsenceRequest
    ): Promise<NatPutLongAbsenceResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/longAbsence`,
            request,
            ContentType.JSON,
        )
    }

    async getLongAbsenceApply(condominiumCd: string, applyId: string):
        Promise<NatGetLongAbsenceResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/longAbsence/${applyId}`
        )
    }

    async approvalLongAbsenceApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsLongAbsenceRequest
    ): Promise<NatPutApprovalsLongAbsenceResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/longAbsence/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async rejectionLongAbsenceApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionLongAbsenceRequest
    ): Promise<NatPutRejectionLongAbsenceResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/longAbsence/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async applyHeavyLoadsCarry(
        condominiumCd: string,
        request: NatPutHeavyLoadsCarryRequest
    ): Promise<NatPutHeavyLoadsCarryResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/heavyLoadsCarries`,
            request,
            ContentType.JSON,
        )
    }

    async getHeavyLoadsCarryApply(condominiumCd: string, applyId: string):
        Promise<NatGetHeavyLoadsCarryApplyResponse> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/heavyLoadsCarries/${applyId}`
        )
    }

    async getHeavyLoadsCarryApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetHeavyLoadsCarryApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/heavyLoadsCarries/${applyId}`
        )
    }

    async rejectionHeavyLoadsCarryApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionHeavyLoadsCarryApplyRequest
    ): Promise<NatPutRejectionHeavyLoadsCarryApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/heavyLoadsCarries/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalHeavyLoadsCarryApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalsHeavyLoadsCarryApplyRequest
    ): Promise<NatPutApprovalsHeavyLoadsCarryApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/heavyLoadsCarries/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }

    async getApplyResult(condominiumCd: string, applyId: string):
        Promise<NatGetApplicationResult> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/${applyId}/applyResult`
        )
    }

    async getParkingUsesForResident(condominiumCd: string, applyId: string):
        Promise<NatGetParkingUsesResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/parkingUses/${applyId}`
        )
    }

    async getPetBreedingForResident(condominiumCd: string, applyId: string):
        Promise<NatGetPetBreedingResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/breedingPets/${applyId}`
        )
    }

    async getPetBreedingStopForResident(condominiumCd: string, applyId: string):
        Promise<NatGetPetBreedingStopResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/breedingPetsStop/${applyId}`
        )
    }

    async getPetMedicalCheckUpReportForResident(condominiumCd: string, applyId: string):
        Promise<NatGetPetMedicalCheckUpReportResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/petMedicalCheckUpReport/${applyId}`
        )
    }

    async getBrowseApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetBrowseApplyResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/browses/${applyId}`
        )
    }

    async getLongAbsenceApplyForResident(condominiumCd: string, applyId: string):
        Promise<NatGetLongAbsenceResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/longAbsence/${applyId}`
        )
    }

    async getConstructionCompleteForResident(condominiumCd: string, applyId: string):
        Promise<NatGetConstructionCompleteResponse> {
        return await this.http.get(
            `/api/resident/condominiums/${condominiumCd}/applications/constructionComplete/${applyId}`
        )
    }

    async applyResidentUserRegistration(
        condominiumCd: string,
        request: NatPostResidentUserRegistrationRequest
    ): Promise<NatPostResidentUserRegistrationResponse> {
        return await this.http.post(
            `/api/resident/condominiums/${condominiumCd}/applications/residentUser`,
            request,
            ContentType.JSON,
        )
    }

    async getUserRegistrationApplyList(
        searchCondition: UserRegistrationApplySearchCondition,
        searchConditionSortInfo: SortOrder[],
    ): Promise<NatGetUserRegistrationApplyList> {
        const sortInfos: string[] = []
        if (searchConditionSortInfo) {
            searchConditionSortInfo.forEach((sortInfo) => {
                sortInfos.push(`${sortInfo.sortKey}:${sortInfo.sortDirection}`)
            })
        }

        return await this.http.post(
            `/api/admin/applications/userRegistrationApplyList`,
            {
                condominiumGroupId: searchCondition.condominiumGroupId || null,
                condominiumCd: searchCondition.condominiumCd || null,
                condominiumName: searchCondition.condominiumName || null,
                applyStatus: searchCondition.applyStatus || null,
                applyId: searchCondition.applyId || null,
                pageNum: searchCondition.pageNum || null,
                page: searchCondition.page ?? null,
                sortInfo: sortInfos,
            },
            ContentType.JSON
        )
    }

    async getUserRegistrationApply(condominiumCd: string, applyId: string):
        Promise<NatGetUserRegistrationApply> {
        return await this.http.get(
            `/api/admin/condominiums/${condominiumCd}/applications/userRegistrationApply/${applyId}`
        )
    }

    async rejectionUserRegistrationApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutRejectionUserRegistrationApplyRequest
    ): Promise<NatPutApprovalUseRegistrationApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/userRegistrationApply/${applyId}/rejections`,
            request,
            ContentType.JSON,
        )
    }

    async approvalUserRegistrationApply(
        condominiumCd: string,
        applyId: string,
        request: NatPutApprovalUseRegistrationApplyRequest
    ): Promise<NatPutApprovalUseRegistrationApplyResponse> {
        return await this.http.post(
            `/api/admin/condominiums/${condominiumCd}/applications/userRegistrationApply/${applyId}/approvals`,
            request,
            ContentType.JSON,
        )
    }
}
